import { useEffect, useState } from 'react'
import { usePageTheme } from '@/components/page-theme-provider'

const POSITION_ZONES = [
  { xMin: 0, xMax: 25, weight: 0.425 },
  { xMin: 75, xMax: 100, weight: 0.425 },
  { xMin: 15, xMax: 85, weight: 0.15 },
]

const EDGE_ZONES = [
  { xMin: 0, xMax: 15, weight: 0.5 },
  { xMin: 85, xMax: 100, weight: 0.5 },
]

// Place splotches around the periphery but away from the direct center text
function randomPosition(zones, index) {
  const roll = Math.random()
  let cumulativeWeight = 0
  let zone = zones[zones.length - 1]

  for (const candidate of zones) {
    cumulativeWeight += candidate.weight

    if (roll <= cumulativeWeight) {
      zone = candidate
      break
    }
  }

  const x = Math.round(zone.xMin + Math.random() * (zone.xMax - zone.xMin))
  const y = index % 2 === 0 ? 0 : 100
  return { x, y }
}

function buildGradient(splotches, freeSpawn, edgeOnly) {
  return splotches
    .map(({ color, size }, index) => {
      const { x, y } = freeSpawn
        ? { x: Math.round(Math.random() * 100), y: Math.round(Math.random() * 100) }
        : randomPosition(edgeOnly ? EDGE_ZONES : POSITION_ZONES, index)
      return `radial-gradient(circle calc(var(--cw) * ${size}) at ${x}% ${y}%, ${color} 0%, transparent 70%)`
    })
    .join(', ')
}

const HeroMesh = ({ scheme, freeSpawn = false, edgeOnly = false, splotches: splotchesOverride }) => {
  const currentTheme = usePageTheme(scheme)
  const splotches = splotchesOverride ?? currentTheme.meshStops
  const [gradient, setGradient] = useState('')

  useEffect(() => {
    setGradient(buildGradient(splotches, freeSpawn, edgeOnly))
  }, [splotches, freeSpawn, edgeOnly])

  if (!gradient) return null

  return (
    <div
      aria-hidden
      className="hero-mesh-splotches absolute inset-0 -z-0 pointer-events-none"
      style={{ backgroundImage: gradient }}
    />
  )
}

export default HeroMesh
